module.exports.animalsName = [
    "Aardvark",
    "Abyssinian",
    "Penguin",
    "Affenpinscher",
    "Hound",
    "Elephant",
    "Civet",
    "Frog",
    "Elephant",
    "Civet",
    "Penguin",
    "Toad",
    "Dog",
    "Terrier",
    "Akbash",
    "Akita",
    "Malamute",
    "Albatross",
    "Tortoise",
    "Alligator",
    "Dachsbracke",
    "Bulldog",
    "Spaniel",
    "Coonhound",
    "Dog",
    "Foxhound",
    "Terrier",
    "Terrier",
    "Spaniel",
    "Dog",
    "Angelfish",
    "Ant",
    "Anteater",
    "Antelope",
    "Dog",
    "Fox",
    "Hare",
    "Wolf",
    "Armadillo",
    "Elephant",
    "Hornet",
    "Civet",
    "Bear",
    "Dog",
    "Mist",
    "Shepherd",
    "Terrier",
    "Avocet",
    "Axolotl",
    "Aye",
    "Baboon",
    "Camel",
    "Badger",
    "Balinese",
    "Civet",
    "Bandicoot",
    "Barb",
    "Owl",
    "Barnacle",
    "Barracuda",
    "Dog",
    "Shark",
    "Hound",
    "Bat",
    "Hound",
    "Beagle",
    "Bear",
    "Collie",
    "Dragon",
    "Beaver",
    "Terrier",
    "Beetle",
    "Tiger",
    "Dog",
    "Frise",
    "Binturong",
    "Bird",
    "Paradise",
    "Birman",
    "Bison",
    "Bear",
    "Rhinoceros",
    "Terrier",
    "Spider",
    "Bloodhound",
    "Dog",
    "Whale",
    "Coonhound",
    "Bobcat",
    "Bombay",
    "Bongo",
    "Bonobo",
    "Booby",
    "Collie",
    "Terrier",
    "utan",
    "Elephant",
    "Terrier",
    "Dolphin",
    "Dog",
    "Spaniel",
    "Terrier",
    "Bear",
    "Budgerigar",
    "Buffalo",
    "Mastiff",
    "Shark",
    "Terrier",
    "Bulldog",
    "Bullfrog",
    "Bee",
    "Burmese",
    "Frog",
    "Butterfly",
    "Fish",
    "Caiman",
    "Lizard",
    "Terrier",
    "Camel",
    "Capybara",
    "Caracal",
    "Cassowary",
    "Cat",
    "Caterpillar",
    "Catfish",
    "Spaniel",
    "Centipede",
    "Fousek",
    "Chameleon",
    "Chamois",
    "Cheetah",
    "Retriever",
    "Chicken",
    "Chihuahua",
    "Chimpanzee",
    "Chinchilla",
    "Chinook",
    "Penguin",
    "Chipmunk",
    "Chow",
    "Cichlid",
    "Leopard",
    "Fish",
    "Spaniel",
    "Coati",
    "Cockroach",
    "Peccary",
    "Collie",
    "Buzzard",
    "Frog",
    "Loon",
    "Toad",
    "Coral",
    "Tamarin",
    "Cougar",
    "Cow",
    "Coyote",
    "Crab",
    "Macaque",
    "Crane",
    "Penguin",
    "Crocodile",
    "Gorilla",
    "Retriever",
    "Cuscus",
    "Cuttlefish",
    "Dachshund",
    "Dalmatian",
    "Frog",
    "Deer",
    "Tortoise",
    "Bracke",
    "Dhole",
    "Dingo",
    "Discus",
    "Pinscher",
    "Dodo",
    "Argentino",
    "Bordeaux",
    "Dolphin",
    "Donkey",
    "Dormouse",
    "Dragonfly",
    "Drever",
    "Duck",
    "Dugong",
    "Dunker",
    "Dolphin",
    "Crocodile",
    "Eagle",
    "Earwig",
    "Gorilla",
    "Gorilla",
    "Echidna",
    "Frog",
    "Mau",
    "Eel",
    "Elephant",
    "Seal",
    "Shrew",
    "Penguin",
    "Tamarin",
    "Emu",
    "Spaniel",
    "Shepherd",
    "Spaniel",
    "Audemer",
    "Dog",
    "Falcon",
    "Fox",
    "Ferret",
    "Spaniel",
    "Whale",
    "Spitz",
    "Toad",
    "Fish",
    "Cat",
    "Flamingo",
    "Retriever",
    "Flounder",
    "Fly",
    "Squirrel",
    "Fossa",
    "Fox",
    "Terrier",
    "Bulldog",
    "Frigatebird",
    "Lizard",
    "Frog",
    "Seal",
    "Penguin",
    "Tortoise",
    "Gar",
    "Gecko",
    "Penguin",
    "Tamarin",
    "Gerbil",
    "Pinscher",
    "Shepherd",
    "Gharial",
    "Snail",
    "Clam",
    "Bear",
    "Schnauzer",
    "Gibbon",
    "Monster",
    "Giraffe",
    "Lizard",
    "Worm",
    "Goat",
    "Tamarin",
    "Oriole",
    "Retriever",
    "Goose",
    "Gopher",
    "Gorilla",
    "Grasshopper",
    "Dane",
    "Shark",
    "Dog",
    "Eater",
    "Dog",
    "Lemur",
    "Shark",
    "Seal",
    "Greyhound",
    "Bear",
    "Grouse",
    "Fowl",
    "Pig",
    "Guppy",
    "Shark",
    "Hamster",
    "Hare",
    "Harrier",
    "Havanese",
    "Hedgehog",
    "Beetle",
    "Crab",
    "Heron",
    "Cattle",
    "Himalayan",
    "Hippopotamus",
    "Bee",
    "Shark",
    "Frog",
    "Horse",
    "Crab",
    "Monkey",
    "Human",
    "Penguin",
    "Hummingbird",
    "Whale",
    "Hyena",
    "Ibis",
    "Hound",
    "Iguana",
    "Impala",
    "Elephant",
    "Squirrel",
    "Rhinoceros",
    "Tortoise",
    "Tiger",
    "Indri",
    "Insect",
    "Setter",
    "WolfHound",
    "Russel",
    "Jackal",
    "Jaguar",
    "Chin",
    "Macaque",
    "Rhinoceros",
    "Javanese",
    "Jellyfish",
    "Kakapo",
    "Kangaroo",
    "Toucan",
    "Whale",
    "Crab",
    "Penguin",
    "Kingfisher",
    "Kiwi",
    "Koala",
    "Dragon",
    "Kudu",
    "Labradoodle",
    "Retriever",
    "Ladybird",
    "Gecko",
    "Lemming",
    "Lemur",
    "Leopard",
    "Cat",
    "Seal",
    "Tortoise",
    "Liger",
    "Lion",
    "Lionfish",
    "Penguin",
    "Lizard",
    "Llama",
    "Lobster",
    "Owl",
    "Lynx",
    "Penguin",
    "Macaw",
    "Penguin",
    "Magpie",
    "Coon",
    "Civet",
    "Tiger",
    "Maltese",
    "Manatee",
    "Mandrill",
    "Ray",
    "Toad",
    "Markhor",
    "Frog",
    "Civet",
    "Mastiff",
    "Mayfly",
    "Meerkat",
    "Millipede",
    "Whale",
    "Mole",
    "Molly",
    "Mongoose",
    "Mongrel",
    "Lizard",
    "Monkey",
    "Eleuth",
    "Moorhen",
    "Moose",
    "Eel",
    "Moth",
    "Gorilla",
    "Lion",
    "Mouse",
    "Mule",
    "Neanderthal",
    "Mastiff",
    "Newfoundland",
    "Newt",
    "Nightingale",
    "Terrier",
    "Forest",
    "Numbat",
    "Shark",
    "Ocelot",
    "Octopus",
    "Okapi",
    "Sheepdog",
    "Olm",
    "Opossum",
    "utan",
    "Ostrich",
    "Otter",
    "Oyster",
    "Pademelon",
    "Panther",
    "Parrot",
    "Monkey",
    "Peacock",
    "Pekingese",
    "Pelican",
    "Penguin",
    "Persian",
    "Pheasant",
    "Tamarin",
    "Pig",
    "Pika",
    "Pike",
    "Armadillo",
    "Piranha",
    "Platypus",
    "Pointer",
    "Frog",
    "Bear",
    "Skater",
    "Poodle",
    "Frog",
    "Porcupine",
    "Possum",
    "Prawn",
    "Monkey",
    "Fish",
    "Puffin",
    "Pug",
    "Puma",
    "Emperor",
    "Moth",
    "Hippopotamus",
    "Marmoset",
    "Quail",
    "Quetzal",
    "Quokka",
    "Quoll",
    "Rabbit",
    "Raccoon",
    "Dog",
    "Tortoise",
    "Ragdoll",
    "Rat",
    "Rattlesnake",
    "Tarantula",
    "Panda",
    "Wolf",
    "Tamarin",
    "Reindeer",
    "Rhinoceros",
    "Dolphin",
    "Turtle",
    "Robin",
    "Hyrax",
    "Penguin",
    "Spoonbill",
    "Rottweiler",
    "Penguin",
    "Blue",
    "Tiger",
    "Bernard",
    "Salamander",
    "Lizard",
    "Saola",
    "Scorpion",
    "Fish",
    "Dragon",
    "Lion",
    "Otter",
    "Slug",
    "Squirt",
    "Turtle",
    "Urchin",
    "Seahorse",
    "Seal",
    "Serval",
    "Sheep",
    "Tzu",
    "Shrimp",
    "Siamese",
    "Fish",
    "Siberian",
    "Husky",
    "Tiger",
    "Dollar",
    "Skunk",
    "Sloth",
    "Worm",
    "Snail",
    "Snake",
    "Turtle",
    "Snowshoe",
    "Owl",
    "Somali",
    "Tiger",
    "Toad",
    "Sparrow",
    "Bear",
    "Whale",
    "Monkey",
    "Dogfish",
    "Sponge",
    "Squid",
    "Squirrel",
    "Monkey",
    "Elephant",
    "Terrier",
    "Beetle",
    "Starfish",
    "Cow",
    "Insect",
    "Stingray",
    "Stoat",
    "Frog",
    "Elephant",
    "utan",
    "Rhinoceros",
    "Tiger",
    "Bear",
    "Swan",
    "Tang",
    "utan",
    "Tapir",
    "Tarsier",
    "Devil",
    "Owl",
    "Termite",
    "Tetra",
    "Devil",
    "Mastiff",
    "Tiffany",
    "Tiger",
    "Salamander",
    "Shark",
    "Tortoise",
    "Toucan",
    "Frog",
    "Tropicbird",
    "Tuatara",
    "Turkey",
    "Angora",
    "Uakari",
    "Uguisu",
    "Umbrellabird",
    "Bat",
    "Monkey",
    "Vulture",
    "Wallaby",
    "Walrus",
    "Warthog",
    "Wasp",
    "Buffalo",
    "Dragon",
    "Vole",
    "Weasel",
    "Corgi",
    "Terrier",
    "Gorilla",
    "Gorilla",
    "Shark",
    "Whippet",
    "Capuchin",
    "Rhinoceros",
    "Tiger",
    "Boar",
    "Wildebeest",
    "Wolf",
    "Wolverine",
    "Wombat",
    "Woodlouse",
    "Woodpecker",
    "Mammoth",
    "Monkey",
    "Wrasse",
    "Yak",
    "Penguin",
    "Terrier",
    "Zebra",
    "Shark",
    "Zebu",
    "Zonkey",
    "Zorse"
]
